import { render, staticRenderFns } from "./ImportPaillettes.vue?vue&type=template&id=57053b68&"
import script from "./ImportPaillettes.vue?vue&type=script&lang=js&"
export * from "./ImportPaillettes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports